// Mock seeds for Daycare Operations modules

export const MOCK_MEDIA = [
  {
    id: "med_1",
    mediaUrl:
      "https://images.unsplash.com/photo-1761208663763-c4d30657c910?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwxfHxkYXljYXJlJTIwY2hpbGRyZW4lMjBwbGF5aW5nJTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4ODA0MjEwM3ww&ixlib=rb-4.1.0&q=85",
    mediaType: "photo",
    caption: "Free play in the toddler room — building blocks morning!",
    childTags: ["ch_1"],
    uploader: "Marcus Vance",
    createdAt: "Today, 9:41 AM",
  },
  {
    id: "med_2",
    mediaUrl:
      "https://images.unsplash.com/photo-1777056481869-feac70afe522?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHwyfHxkYXljYXJlJTIwY2hpbGRyZW4lMjBwbGF5aW5nJTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4ODA0MjEwM3ww&ixlib=rb-4.1.0&q=85",
    mediaType: "photo",
    caption: "Snack time crew — everyone finished their fruit cups.",
    childTags: ["ch_1", "ch_2"],
    uploader: "Elena Rostova",
    createdAt: "Yesterday, 11:15 AM",
  },
  {
    id: "med_3",
    mediaUrl:
      "https://images.unsplash.com/photo-1786292949404-084cbd10c7b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNzl8MHwxfHNlYXJjaHw0fHxkYXljYXJlJTIwY2hpbGRyZW4lMjBwbGF5aW5nJTIwY2xhc3Nyb29tfGVufDB8fHx8MTc4ODA0MjEwM3ww&ixlib=rb-4.1.0&q=85",
    mediaType: "photo",
    caption: "Story circle — hands up for the big book!",
    childTags: ["ch_2"],
    uploader: "Marcus Vance",
    createdAt: "Yesterday, 10:05 AM",
  },
];

export const MOCK_PICKUPS = {
  ch_1: [
    { id: "pk_1", contactName: "Sarah Jenkins", relationship: "Mother", phone: "+1 (555) 014-4432", isActive: true },
    { id: "pk_2", contactName: "Tom Jenkins", relationship: "Father", phone: "+1 (555) 014-4433", isActive: true },
  ],
  ch_2: [{ id: "pk_3", contactName: "Rosa Torres", relationship: "Grandmother", phone: "+1 (555) 011-7788", isActive: true }],
};

export const MOCK_DOCS = [
  {
    id: "doc_1",
    childId: "ch_1",
    title: "Field Trip Permission Slip — Pumpkin Patch",
    isSigned: false,
    signedBy: null,
    signedAt: null,
  },
  {
    id: "doc_2",
    childId: "ch_1",
    title: "Photo & Media Release Waiver (2026–27)",
    isSigned: true,
    signedBy: "Sarah Jenkins",
    signedAt: "Aug 10, 2026",
  },
  {
    id: "doc_3",
    childId: "ch_2",
    title: "Sunscreen Application Authorization",
    isSigned: false,
    signedBy: null,
    signedAt: null,
  },
];

export const MOCK_COMMS = [
  {
    id: "com_1",
    channel: "email",
    recipientType: "all_parents",
    destination: "all-parents@sunshineacademy.com",
    message: "Reminder: Picture day is Thursday — dress your best!",
    sentAt: "Aug 14, 2026 3:12 PM",
    status: "sent",
  },
];

export const MOCK_LOGS = [
  { id: "log_1", user: "Elena Rostova", action: "UPDATE", targetTable: "facilities", details: "License details re-verified", createdAt: "Aug 15, 2026 09:02 AM" },
  { id: "log_2", user: "Marcus Vance", action: "CREATE", targetTable: "media_posts", details: "Uploaded 1 photo to parent feed", createdAt: "Aug 14, 2026 04:40 PM" },
  { id: "log_3", user: "Elena Rostova", action: "DISPATCH_COMMUNICATION", targetTable: "communications", details: "email → all-parents@sunshineacademy.com", createdAt: "Aug 14, 2026 03:12 PM" },
  { id: "log_4", user: "System", action: "VIEW", targetTable: "children", details: "Compliance audit export generated", createdAt: "Aug 13, 2026 08:00 AM" },
];

// ---------- Compliance / Ratio Engine ----------
export const CLASSROOM_RULES = [
  { id: "cls_infants", name: "Infants (0–18m)", ratioLimit: 3, children: 5, staff: 2 },
  { id: "cls_toddlers", name: "Toddlers (18m–3y)", ratioLimit: 4, children: 9, staff: 2 },
  { id: "cls_preschool", name: "Preschool (3–5y)", ratioLimit: 8, children: 18, staff: 2 },
];

export const STAFF_CREDENTIALS = [
  { id: "cred_1", staff: "Marcus Vance", credential: "CPR / First Aid", expiresAt: "Sep 20, 2026", daysLeft: 22 },
  { id: "cred_2", staff: "Elena Rostova", credential: "Director License", expiresAt: "Mar 1, 2027", daysLeft: 185 },
  { id: "cred_3", staff: "Marcus Vance", credential: "Background Check", expiresAt: "Aug 9, 2027", daysLeft: 346 },
];

// ---------- Parent Applications ----------
export const PROGRAMS = ["Full-Time Toddler Care", "Part-Time Preschool", "After-School Program", "Infant Care", "Summer Camp"];

export const MOCK_APPLICATIONS = [
  {
    id: "app_1",
    parentName: "Sarah Jenkins",
    childName: "Leo Jenkins",
    program: "Full-Time Toddler Care",
    facility: "Sunshine Academy - Main Campus",
    notes: "Leo is potty training and loves story time.",
    status: "approved",
    submittedAt: "Aug 10, 2026",
  },
  {
    id: "app_2",
    parentName: "David Park",
    childName: "Sophie Park",
    program: "Part-Time Preschool",
    facility: "Sunshine Academy - Main Campus",
    notes: "Looking for Mon/Wed/Fri mornings.",
    status: "pending",
    submittedAt: "Aug 18, 2026",
  },
];

// Caregiver/daycare coordinates around Sacramento, CA for the map
export const MAP_CENTER = [38.5816, -121.4944];
export const CAREGIVER_GEO = {
  cg_1: { lat: 38.5949, lng: -121.4703 },
  cg_2: { lat: 38.5649, lng: -121.4611 },
  cg_3: { lat: 38.6002, lng: -121.5055 },
  cg_4: { lat: 38.5505, lng: -121.5305 },
  cg_5: { lat: 38.5715, lng: -121.4405 },
  cg_6: { lat: 38.6125, lng: -121.4885 },
};
export const DAYCARE_GEO = [
  { id: "dc_1", name: "Sunshine Academy - Main Campus", lat: 38.5816, lng: -121.4944, capacity: 120 },
  { id: "dc_2", name: "Little Sprouts", lat: 38.5675, lng: -121.4755, capacity: 68 },
  { id: "dc_3", name: "Bright Beginnings", lat: 38.6015, lng: -121.4615, capacity: 84 },
];
